import { Component } from '@angular/core';

@Component({
  selector: 'upsc-flex-header',
  templateUrl: './flex-header.component.html',
  styleUrls: ['./flex-header.component.scss']
})
export class FlexHeaderComponent {
  isCanadaUser: boolean;
  constructor() {
    
  }

  public ngOnInit() {
    document.addEventListener('click', function(event) {
      const navbar = document.querySelector('#navbarSupportedContent'); // Replace '.navbar' with your navbar selector
      const toggler = document.querySelector('.navbar-toggler'); // Replace '.navbar-toggler' with your toggler selector
      const isClickInsideNavbar = navbar.contains(event.target as Node) || (toggler && toggler.contains(event.target as Node));
    
      if (!isClickInsideNavbar && navbar.classList.contains('show')) { // Assuming 'show' class controls navbar visibility
        navbar.classList.remove('show');
      }
    });
  }

  isPageInit: boolean = false;
  ngAfterContentInit() {
    this.isPageInit = true;   
  }

  toggleNavbar(){
    let el = document.getElementById("navbarSupportedContent");
    el.classList.toggle('show');
  }

  public ngOnDestroy() {
    
  }
}
